// @ts-nocheck
/* eslint-disable */
export const appChevronDownV224Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 8L12.5 15.5L20 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'chevron-down-v-2-24' as const
};